import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authIsLoginSelector } from 'redux/auth/selectors';
import { actions } from 'redux/auth/slice';
import { ConfigProvider } from 'antd';
import LoginForm from 'components/loginForm';

const Login = () => {
  const dispatch = useDispatch();
  const isLoginIn = useSelector(authIsLoginSelector);
  const submitLogin = useCallback(
    (values) => {
      dispatch(actions.fetch(values));
    },
    [dispatch],
  );

  const CHAZKI_BACKGROUND = '#ffffff';
  const CHAZKI_BLUE = '#257de2';

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: CHAZKI_BLUE,
          colorBgBase: CHAZKI_BACKGROUND,
        },
      }}
    >
      <LoginForm onSubmit={submitLogin} isLoggingIn={isLoginIn} />
    </ConfigProvider>
  );
};

export default Login;
